<template>
  <el-row type="flex" justify="end"> </el-row>
</template>
<script>
export default {
  name: "dashboard-footer",
};
</script>